import { Reducer } from 'redux';
import {
  WizardState,
  WizardActionTypes,
  LOAD_SCHEMA_START,
  LOAD_SCHEMA_SUCCESS,
  LOAD_SCHEMA_ERROR,
  SUBMIT_APPLICATION_START,
  SUBMIT_APPLICATION_SUCCESS,
  SUBMIT_APPLICATION_ERROR,
  CONTINUE_TO_FORM
} from './types';

export const initialState: WizardState = {
  continueWithForm: false,
  loading: false,
  submitted: false,
  submittingApplication: false
};

const wizardReducer: Reducer<WizardState, WizardActionTypes> = (
  state = initialState,
  action: WizardActionTypes
): WizardState => {
  switch (action.type) {
    case LOAD_SCHEMA_START: {
      return { ...state, loading: true };
    }
    case LOAD_SCHEMA_SUCCESS: {
      return {
        ...state,
        loading: false,
        schema: action.schema,
        data: action.schema.data,
        formIds: action.formIds,
        ...action.asyncGroups,
        fetchError: undefined
      };
    }
    case LOAD_SCHEMA_ERROR: {
      return { ...state, loading: false, fetchError: action.errorMsg };
    }
    case SUBMIT_APPLICATION_START: {
      return {
        ...state,
        submittingApplication: true
      };
    }
    case SUBMIT_APPLICATION_SUCCESS: {
      return {
        ...state,
        submittingApplication: false,
        applicationSubmitError: undefined,
        submitted: true,
        confirmationNumber: action.confirmationNumber
      };
    }
    case SUBMIT_APPLICATION_ERROR: {
      return {
        ...state,
        submittingApplication: false,
        applicationSubmitError: action.error
      };
    }
    case CONTINUE_TO_FORM: {
      return {
        ...state,
        continueWithForm: true
      };
    }
    default: {
      return state;
    }
  }
};

export default wizardReducer;
